<template>
  <el-container>
    <el-header>
      <common-header :enable-to-login="false"/>
    </el-header>
    <el-main class="maincontainer">
      <div class="login-title">
        <div class="t1">{{ $t('lang.loginPage.ceibsStudentCert') }}</div>
      </div>
      <div>
        <el-row style="margin-left: 0; margin-right: 0; margin-top: 44px;">
          <el-col :span="10" :offset="12">
            <el-card class="box-card">
              <div slot="header" class="cardheader">
                <div>{{ $t('lang.loginPage.applyQuery') }}</div>
              </div>
              <el-form ref="form" :model="searchForm">
                <div style="padding-bottom: 10px">
                  <el-input v-model="searchForm.idNo" class="requestinput"
                            :placeholder="$t('lang.loginPage.inputYourId')"></el-input>
                  <el-input v-model="searchForm.applyNo" class="requestinput"
                            :placeholder="$t('lang.loginPage.inputApplyNo')"></el-input>
                </div>
                <el-button size="mini" type="ceibsprimary" @click="query">{{ $t('lang.loginPage.query') }}</el-button>
              </el-form>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import CommonHeader from '@/components/common/commonHeader'
import { mapGetters } from 'vuex'
import { removeToken } from '@/util/util.ruquest'
import { quickQuery } from '@/api/apply'

export default {
  name: 'QuickQuery',
  components: { CommonHeader },
  computed: {
    ...mapGetters([
      'currentApplyId'
    ])
  },
  mounted () {
    document.getElementsByTagName('body')[0].classList.add('ceibs-login')
  },
  destroyed () {
    document.getElementsByTagName('body')[0].classList.remove('ceibs-login')
  },
  data () {
    return {
      searchForm: {
        idNo: '',
        applyNo: ''
      }
    }
  },
  methods: {
    query () {
      removeToken()
      if (!this.searchForm.idNo || this.searchForm.idNo === '') {
        this.$message.error(this.$t('lang.loginPage.pleaseInputYourIdNo'))
        return
      }
      if (!this.searchForm.applyNo || this.searchForm.applyNo === '') {
        this.$message.error(this.$t('lang.loginPage.pleaseInputYourApplicationNo'))
        return
      }
      quickQuery(this.searchForm).then(res => {
        this.$store.dispatch('setQuickQueryApplyId', res.data.id)
        this.$router.push('/applyList')
      })
    }
  }
}
</script>

<style scoped>
.login-title {
  display: flex;
  align-items: baseline;
  justify-content: center;
  font-weight: bold;
  color: #fff;
  letter-spacing: 2px;
  margin-top: 50px;
  padding-top: 50px;
  padding-bottom: 50px;
}

.login-title .t1 {
  font-size: 42px;
  text-shadow: 2px 2px 5px rgb(136 136 136 / 25%);
}

.box-card {
  background-color: unset;
  border-radius: 8px;
  border: none;
  box-shadow: 3px 7px 12px 1px rgb(0 0 0 / 45%);
}

/deep/ .el-card__header {
  padding: 0;
}

/deep/ .el-card__body {
  background-color: rgba(255, 255, 255, 0.85);
  /*height: 160px;*/
}

/deep/ .el-col {
  padding-bottom: 30px;
}

.notice {
  text-align: left;
  color: #565656;
}

.notice-title {
  font-weight: bold;
  font-size: 18px;
}

.notice-content {
  margin-top: 0;
  font-size: 14px;
  height: 75px;
  display: block;
  overflow-y: auto;
}

.box-card {
  background-color: unset;
  border-radius: 8px;
  border: none;
  box-shadow: 3px 7px 12px 1px rgb(0 0 0 / 45%);
}

.cardheader {
  background: linear-gradient(to left, #a2100e, rgba(162, 16, 14, 0.5));
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 25px;
  color: #fff;
  font-weight: bold;
  padding: 0 20px;
  text-shadow: 2px 2px 5px rgb(8 8 8 / 19%);
  text-align: center;
}

.request-body {
  text-align: center;
}

.card-tip {
  font-size: 14px;
  color: rgba(86, 86, 86, 0.63);
  font-weight: bold;
  margin-top: 5px;
  margin-bottom: 5px;
}

/deep/ .el-input__inner {
  background-color: #c5c5c5;
  border-radius: 0;
  height: 34px;
  line-height: 34px;
  margin-bottom: 5px;
  text-align: center;
}

/deep/ .el-input__inner::placeholder {
  color: #565656;
}

/deep/ .el-card__header {
  padding: 0;
}

/deep/ .el-card__body {
  background-color: rgba(255, 255, 255, 0.85);
  /*height: 160px;*/
}
</style>
